import React, { useEffect } from "react";
import heading from "../../../assets/images/heading.png";
import useApi from "../../hooks/useApi";
import config from "../../Services/config";
import { Link } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
const PriceList = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const { data, fetchData } = useApi();
  const baseUrl = config.apiUrl;
  useEffect(() => {
    const apiUrl = `${baseUrl}/card-types`;
    const options = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    fetchData(apiUrl, options);
    window.scrollTo(0, 0);
  }, []);
  // console.log(data?.body[0]);
  const handleLoginNavigation = () => {
    const currentUrl = window.location.pathname + window.location.search;
    navigate(`/login?redirect=${encodeURIComponent(currentUrl)}`, {
      replace: true,
    });
  };
  return (
    <div className="price-list  w-full  xl:pb-[60px]  bg-white">
      <div className="mx-auto w-[370px] sm:w-[600px] md:w-[700px] lg:w-[980px] xl:w-[1200px]">
        <div className="relative mb-[30px]  mx-auto ">
          <img
            className="absolute left-[50%] top-[-20px]"
            src={heading}
            alt=""
          />
          <h1 className="text-[#1E2865] font-bold text-[24px] lg:text-[36px] mb-8 text-center">
            البطــــــــــاقــــــــــات
          </h1>
          <p className="text-center text-[16px] lg:text-[20px]">
            {" "}
            عرض البطاقات الحصري
          </p>
        </div>

        <div className="flex justify-center  mx-auto   ">
          {/* <div className="card-orders bg-[#e5faff] xl:w-[406px] h-[688px] text-center">
            <div>
              <h1 className="text-[40px] text-[#4C94D3]">مميـــــزة</h1>
              <h2 className="font-extrabold text-[36px] text-[#1E2865]">150</h2>
              <h2 className="text-[#30ECAC] text-[26px]">
                <del>200</del>
              </h2>
              <h2 className="font-extrabold text-[36px] text-[#1E2865]">
                {" "}
                ريـــــــال
              </h2>
            </div>
            <div className="features-orders mb-4">
              <button className="send-req w-[100%] h-[44px] text-white font-bold mb-5">
                ارسال الطلب
              </button>
              <div className="text-right mb-4 leading-[2]">
                <p>. مميزات البطاقه هنا</p>
                <p>. مميزات البطاقه هنا</p>
                <p>. مميزات البطاقه هنا</p>
              </div>
            </div>
            <div className="card-features mt-4">
              <h1 className="text-right text-[20px] font-bold text-[#2E2E2E]">
                تشمل البطاقه{" "}
              </h1>
              <div className="text-right">
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
              </div>
            </div>
          </div> */}
          <div className="card-orders  bg-[#e5faff]  xl:w-[406px]    h-[688px] text-center">
            <div>
              <h1 className="text-[40px] text-[#4C94D3]">
                {data?.body[0].name}
              </h1>
              <h2 className="font-extrabold text-[36px] text-[#1E2865]">
                {data?.body[0].annual_fee}
              </h2>
              {/* <h2 className="text-[#30ECAC] text-[26px]">
                <del>200</del>
              </h2> */}
              <h2 className="font-extrabold text-[36px] text-[#1E2865]">
                {" "}
                ريـــــــال
              </h2>
            </div>
            <div className="features-orders mb-4">
              <>
                {user ? (
                  <Link to={`/card-types/${data?.body[0]?.id}`}>
                    <button className="send-req   w-[100%] h-[44px] text-white font-bold mb-5">
                      اطلب البطاقة
                    </button>
                  </Link>
                ) : (
                  <Link to={`/login-payment`}>
                    <button
                      disabled={!data}
                      onClick={() => handleLoginNavigation}
                      className="send-req   w-[100%] h-[44px] text-white font-bold mb-5"
                    >
                      اطلب البطاقة
                    </button>
                  </Link>
                )}
              </>

              {/* <Link to={`/card-types/${data?.body[0]?.id}`}>
                <button className="send-req   w-[100%] h-[44px] text-white font-bold mb-5">
                  اطلب البطاقة
                </button>
              </Link> */}

              <div className="text-right mb-4 leading-[2]">
                <p>{data?.body[0].description}</p>
              </div>
            </div>
            <div className="card-features mt-4">
              <h1 className="text-right text-[20px] font-bold text-[#2E2E2E]">
                تشمل البطاقه{" "}
              </h1>
              <div className="text-right">
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">
                    {data?.body[0].features}
                  </span>
                </p>
              </div>
            </div>
          </div>
          {/* <div className="card-orders bg-[#e5faff]  xl:w-[406px] h-[688px] text-center">
            <div>
              <h1 className="text-[40px] text-[#4C94D3]">عاديــــــة </h1>
              <h2 className="font-extrabold text-[36px] text-[#1E2865]">150</h2>
              <h2 className="text-[#30ECAC] text-[26px]">
                <del>200</del>
              </h2>
              <h2 className="font-extrabold text-[36px] text-[#1E2865]">
                {" "}
                ريـــــــال
              </h2>
            </div>
            <div className="features-orders mb-4">
              <button className="send-req w-[100%] h-[44px] text-white font-bold mb-5">
                ارسال الطلب
              </button>
              <div className="text-right mb-4 leading-[2]">
                <p>. مميزات البطاقه هنا</p>
                <p>. مميزات البطاقه هنا</p>
                <p>. مميزات البطاقه هنا</p>
              </div>
            </div>
            <div className="card-features mt-4">
              <h1 className="text-right text-[20px] font-bold text-[#2E2E2E]">
                تشمل البطاقه{" "}
              </h1>
              <div className="text-right">
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
                <p>
                  <span className="text-#2B1C50]">✓</span>{" "}
                  <span className="text-[#2e2e2e]">مميزات البطاقه هنا</span>
                </p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PriceList;
